//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UMUM         from "../../../library/umum"        ;
import WILAYAH      from "../../../library/getWilayah"  ;
import CHART        from '../../../library/chart'       ;

export default {
  data() {
    return { 
      form: {
        des_kel:this.$store.state.ID_DES_KEL,
        tahun: "2020",
      },
      list_data: [],
      cek_load_data : true,
      listKegiatan: [],

      page_limit: 10,
      page_first: 1,
      page_last: 0,
      cari_value: "",

      mdl_lihat : false,

      UMUM: UMUM
    };
  },
  methods: {
// URL_CNT_DESA_FASILITAS_PENDIDIKAN
// char_fasilitas_pendidikan
    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_CNT_DESA_FASILITAS_PEMERINTAHAN + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
        //   authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              tahun: this.form.tahun,
              des_kel : this.form.des_kel
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },

    // char_data_status_sosial
    chartnya : async function(){
      var body = this.form
      var tahun = this.form.tahun
      var dataArray = await CHART.postData(this.$store.state.url.URL_CNT_DESA_FASILITAS_PEMERINTAHAN, 'chart', body);
    //   console.log(dataArray)
      CHART.BarChart('barchartnya', 'Layanan Pemerintahan', 'Data', dataArray.uraian, dataArray.jumlah, 'Unit') 
    },
 

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
            this.chartnya();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },  
    // ====================================== PAGINATE ====================================
  },
  mounted() {
    this.$store.state.kegiatan.id = this.$route.query.id; 
    this.form.tahun = this.UMUM.getTahun();
    WILAYAH.getListDesKelFull();
    this.cari_data();
  }
};
